module.exports = __webpack_public_path__ + "img/onboarding_waiting_compute_kpi.acc79bbf.gif";